import React from 'react';
import { Ornament } from './Ornament';
import { Reveal } from './Reveal';
import { EVENT } from '../data/invitation';
export function Closing() {
  return <footer className="relative w-full overflow-hidden bg-paper-100 px-6 py-28 sm:px-10 sm:py-36 lg:px-16" data-id="element-6" data-mp="3t2vjf0ix2qt2">
      <div aria-hidden="true" className="paper-grain pointer-events-none absolute inset-0 opacity-60" data-id="element-7" data-mp="3f7jpuwghz6dq" />

      <div className="relative mx-auto max-w-5xl" data-id="element-8" data-mp="35b6nla6vzk7d">
        <Reveal data-id="element-9" data-mp="35af4gyuh7exz">
          <p className="font-serif text-[clamp(2.25rem,7vw,5rem)] font-light leading-[1.05] text-ink-900" data-id="element-10" data-mp="359vin71pg6eo">
            Se vidimo v 40. poglavju.
          </p>
        </Reveal>

        <Reveal delay={0.06} data-id="element-11" data-mp="2wbto9ach8c0d">
          <Ornament align="left" className="mt-12" data-id="element-12" data-mp="2wcl9br8g6rce" />
          <p className="mt-8 font-serif text-xl font-light italic text-accent-500 sm:text-2xl" data-id="element-13" data-mp="30bbync6o94oy">
            {EVENT.dateLong} &middot; {EVENT.place}
          </p>
          <div className="mt-16 flex items-center justify-between border-t border-ink-900/10 pt-6 text-[0.65rem] uppercase tracking-label text-ink-400" data-id="element-14" data-mp="uhariyahwo4w">
            <span data-id="element-15" data-mp="3r0o0towz2z3i">Konec vabila</span>
            <span aria-hidden="true" data-id="element-16" data-mp="3qzmdakyrsk4w">40</span>
          </div>
        </Reveal>
      </div>
    </footer>;
}